import { Component, createMemo } from 'solid-js';
import {
  MissionDetailsSelection,
  useApiServices,
} from '@mobile-mapping/providers';
import { formatUserDisplayName } from '@data-access/connect/tc-user';
import { useConnectProject } from '@trimble/connect-project-providers';
import { MissionDetails } from '@trimble/ui-components/solidjs';

export interface MissionDetailsContainerProps {
  readonly mission: MissionDetailsSelection;
  onClose(): void;
}

export const MissionDetailsContainer: Component<
  MissionDetailsContainerProps
> = (props) => {
  const { mobileMappingApi, tcUserApi } = useApiServices();
  const { selectedTenantTrn } = useConnectProject();

  /* eslint-disable solid/reactivity -- Query hooks handle reactivity internally */
  const missionQuery = mobileMappingApi.getMissionQuery(
    selectedTenantTrn,
    () => props.mission.missionTrn
  );
  /* eslint-enable solid/reactivity */

  const missionData = createMemo(() => {
    if (!missionQuery.isSuccess) return undefined;
    return missionQuery.data;
  });

  /* eslint-disable solid/reactivity -- Query hooks handle reactivity internally */
  const createdByQuery = tcUserApi.getUserByIdQuery(
    () => missionData()?.createdBy
  );
  const modifiedByQuery = tcUserApi.getUserByIdQuery(
    () => missionData()?.modifiedBy
  );
  /* eslint-enable solid/reactivity */

  const createdByName = createMemo(() =>
    formatUserDisplayName(createdByQuery.data)
  );
  const modifiedByName = createMemo(() =>
    formatUserDisplayName(modifiedByQuery.data)
  );

  return (
    <MissionDetails
      name={props.mission.name}
      isLoading={missionQuery.isLoading}
      isError={missionQuery.isError}
      createdAt={missionData()?.createdAt}
      createdBy={createdByName() || undefined}
      modifiedOn={missionData()?.modifiedOn}
      modifiedBy={modifiedByName() || undefined}
      onClose={props.onClose}
    />
  );
};
